// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_meU","cls2":"VideoPlayerMainContent-cls2_g2L VideoPlayerMainContent-cls1_meU"};